import { render, staticRenderFns } from "./AddProductView.vue?vue&type=template&id=6fa9410c"
import script from "./AddProductView.vue?vue&type=script&lang=js"
export * from "./AddProductView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports